// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-form {
  padding: 32px;
  max-width: 440px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(16px);
  border-radius: 20px;
  box-shadow: var(--shadow-xl);
  border: 1px solid rgba(255, 255, 255, 0.6);
}
.auth-form .auth-form-header {
  text-align: center;
  margin-bottom: 32px;
}
.auth-form .auth-form-header h3 {
  margin-bottom: 8px;
  color: #1e293b;
  font-weight: 700;
  font-size: 24px;
  letter-spacing: -0.5px;
}
.auth-form .auth-form-header .ant-typography {
  color: #64748b;
  font-size: 15px;
}
.auth-form .ant-form .ant-form-item {
  margin-bottom: 24px;
}
.auth-form .ant-form .ant-form-item .ant-form-item-label {
  padding-bottom: 6px;
}
.auth-form .ant-form .ant-form-item .ant-form-item-label label {
  font-weight: 600;
  color: #475569;
  font-size: 13px;
}
.auth-form .ant-form .ant-form-item .ant-input-affix-wrapper,
.auth-form .ant-form .ant-form-item .ant-input {
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  padding: 10px 12px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.8);
}
.auth-form .ant-form .ant-form-item .ant-input-affix-wrapper:hover,
.auth-form .ant-form .ant-form-item .ant-input:hover {
  border-color: var(--float-primary-light);
  background: #fff;
}
.auth-form .ant-form .ant-form-item .ant-input-affix-wrapper:focus,
.auth-form .ant-form .ant-form-item .ant-input:focus,
.auth-form .ant-form .ant-form-item .ant-input-affix-wrapper.ant-input-affix-wrapper-focused,
.auth-form .ant-form .ant-form-item .ant-input.ant-input-affix-wrapper-focused {
  border-color: var(--float-primary);
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
  background: #fff;
}
.auth-form .ant-form .ant-form-item .ant-input-prefix {
  color: #94a3b8;
  margin-right: 10px;
}
.auth-form .ant-form .ant-btn {
  border-radius: 12px;
  height: 44px;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.3px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.auth-form .ant-form .ant-btn.ant-btn-primary {
  background: var(--gradient-primary);
  border: none;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}
.auth-form .ant-form .ant-btn.ant-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
  opacity: 0.95;
}
.auth-form .ant-form .ant-btn.ant-btn-primary:active {
  transform: translateY(0);
}
.auth-form .ant-divider {
  margin: 32px 0 24px 0;
  border-color: #e2e8f0;
}
.auth-form .ant-divider .ant-divider-inner-text {
  color: #94a3b8;
  font-size: 12px;
  padding: 0 16px;
}
.auth-form .ant-typography.ant-typography-link {
  color: var(--float-primary);
  font-weight: 600;
  transition: color 0.3s;
}
.auth-form .ant-typography.ant-typography-link:hover {
  color: var(--float-primary-light);
}
.auth-form .ant-alert {
  border-radius: 10px;
  margin-bottom: 20px;
  border: none;
}
.auth-form .ant-select .ant-select-selector {
  border-radius: 12px;
  border: 1px solid #cbd5e1;
  transition: all 0.3s;
  height: 44px;
  display: flex;
  align-items: center;
}
.auth-form .ant-select .ant-select-selector:hover {
  border-color: var(--float-primary-light);
}
.auth-form .ant-select .ant-select-selector.ant-select-focused {
  border-color: var(--float-primary);
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
}
.auth-modal .ant-modal-content {
  border-radius: 24px;
  overflow: hidden;
  background: transparent;
  box-shadow: none;
  padding: 0;
}
.auth-modal .ant-modal-header {
  display: none;
}
.auth-modal .ant-modal-body {
  padding: 0;
}
.auth-modal .ant-modal-close {
  top: 24px;
  right: 24px;
  color: #94a3b8;
}
.auth-modal .ant-modal-close:hover {
  color: #1e293b;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 50%;
}
@media (max-width: 576px) {
  .auth-form {
    padding: 24px;
    max-width: 100%;
    border-radius: 16px;
  }
  .auth-form .auth-form-header {
    margin-bottom: 24px;
  }
  .auth-form .ant-form .ant-form-item {
    margin-bottom: 16px;
  }
  .auth-modal .ant-modal {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/renderer/components/auth/AuthForms.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;EACA,0CAAA;AACF;AATA;EAWI,kBAAA;EACA,mBAAA;AACJ;AAbA;EAeM,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AACN;AApBA;EAuBM,cAAA;EACA,eAAA;AAAN;AAxBA;EA8BM,mBAAA;AAHN;AA3BA;EAiCQ,mBAAA;AAHR;AA9BA;EAoCU,gBAAA;EACA,cAAA;EACA,eAAA;AAHV;AAnCA;;EA4CQ,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;AALR;AAOQ;;EACE,wCAAA;EACA,gBAAA;AAJV;AAOQ;;;;EAEE,kCAAA;EACA,4CAAA;EACA,gBAAA;AAHV;AAxDA;EAgEQ,cAAA;EACA,kBAAA;AALR;AA5DA;EAsEM,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,iDAAA;AAPN;AASM;EACE,mCAAA;EACA,YAAA;EACA,6CAAA;AAPR;AASQ;EACE,2BAAA;EACA,6CAAA;EACA,aAAA;AAPV;AAUQ;EACE,wBAAA;AARV;AAjFA;EAgGI,qBAAA;EACA,qBAAA;AAZJ;AArFA;EAoGM,cAAA;EACA,eAAA;EACA,eAAA;AAZN;AAiBI;EACE,2BAAA;EACA,gBAAA;EACA,sBAAA;AAfN;AAiBM;EACE,iCAAA;AAfR;AAlGA;EAuHI,mBAAA;EACA,mBAAA;EACA,YAAA;AAlBJ;AAvGA;EA8HM,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AApBN;AAsBM;EACE,wCAAA;AApBR;AAuBM;EACE,kCAAA;EACA,4CAAA;AArBR;AA2BA;EAEI,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AA1BJ;AAoBA;EAUI,aAAA;AA3BJ;AAiBA;EAcI,UAAA;AA5BJ;AAcA;EAkBI,SAAA;EACA,WAAA;EACA,cAAA;AA7BJ;AA+BI;EACE,cAAA;EACA,+BAAA;EACA,kBAAA;AA7BN;AAmCA;EACE;IACE,aAAA;IACA,eAAA;IACA,mBAAA;EAjCF;EA8BA;IAMI,mBAAA;EAjCJ;EA2BA;IAWM,mBAAA;EAnCN;EAwCA;IAEI,YAAA;IACA,6BAAA;EAvCJ;AACF","sourcesContent":[".auth-form {\n  padding: 32px;\n  max-width: 440px;\n  margin: 0 auto;\n  background: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(16px);\n  border-radius: 20px;\n  box-shadow: var(--shadow-xl);\n  border: 1px solid rgba(255, 255, 255, 0.6);\n\n  .auth-form-header {\n    text-align: center;\n    margin-bottom: 32px;\n\n    h3 {\n      margin-bottom: 8px;\n      color: #1e293b;\n      font-weight: 700;\n      font-size: 24px;\n      letter-spacing: -0.5px;\n    }\n\n    .ant-typography {\n      color: #64748b;\n      font-size: 15px;\n    }\n  }\n\n  .ant-form {\n    .ant-form-item {\n      margin-bottom: 24px;\n\n      .ant-form-item-label {\n        padding-bottom: 6px;\n\n        label {\n          font-weight: 600;\n          color: #475569;\n          font-size: 13px;\n        }\n      }\n\n      .ant-input-affix-wrapper,\n      .ant-input {\n        border-radius: 12px;\n        border: 1px solid #cbd5e1;\n        padding: 10px 12px;\n        transition: all 0.3s ease;\n        background: rgba(255, 255, 255, 0.8);\n\n        &:hover {\n          border-color: var(--float-primary-light);\n          background: #fff;\n        }\n\n        &:focus,\n        &.ant-input-affix-wrapper-focused {\n          border-color: var(--float-primary);\n          box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);\n          background: #fff;\n        }\n      }\n\n      .ant-input-prefix {\n        color: #94a3b8;\n        margin-right: 10px;\n      }\n    }\n\n    .ant-btn {\n      border-radius: 12px;\n      height: 44px;\n      font-weight: 600;\n      font-size: 15px;\n      letter-spacing: 0.3px;\n      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n      &.ant-btn-primary {\n        background: var(--gradient-primary);\n        border: none;\n        box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n\n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n          opacity: 0.95;\n        }\n\n        &:active {\n          transform: translateY(0);\n        }\n      }\n    }\n  }\n\n  .ant-divider {\n    margin: 32px 0 24px 0;\n    border-color: #e2e8f0;\n\n    .ant-divider-inner-text {\n      color: #94a3b8;\n      font-size: 12px;\n      padding: 0 16px;\n    }\n  }\n\n  .ant-typography {\n    &.ant-typography-link {\n      color: var(--float-primary);\n      font-weight: 600;\n      transition: color 0.3s;\n\n      &:hover {\n        color: var(--float-primary-light);\n      }\n    }\n  }\n\n  .ant-alert {\n    border-radius: 10px;\n    margin-bottom: 20px;\n    border: none;\n  }\n\n  .ant-select {\n    .ant-select-selector {\n      border-radius: 12px;\n      border: 1px solid #cbd5e1;\n      transition: all 0.3s;\n      height: 44px;\n      display: flex;\n      align-items: center;\n\n      &:hover {\n        border-color: var(--float-primary-light);\n      }\n\n      &.ant-select-focused {\n        border-color: var(--float-primary);\n        box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);\n      }\n    }\n  }\n}\n\n.auth-modal {\n  .ant-modal-content {\n    border-radius: 24px;\n    overflow: hidden;\n    background: transparent;\n    box-shadow: none;\n    padding: 0;\n  }\n\n  .ant-modal-header {\n    display: none;\n  }\n\n  .ant-modal-body {\n    padding: 0;\n  }\n  \n  .ant-modal-close {\n    top: 24px;\n    right: 24px;\n    color: #94a3b8;\n    \n    &:hover {\n      color: #1e293b;\n      background: rgba(0,0,0,0.05);\n      border-radius: 50%;\n    }\n  }\n}\n\n// 响应式设计\n@media (max-width: 576px) {\n  .auth-form {\n    padding: 24px;\n    max-width: 100%;\n    border-radius: 16px;\n\n    .auth-form-header {\n      margin-bottom: 24px;\n    }\n\n    .ant-form {\n      .ant-form-item {\n        margin-bottom: 16px;\n      }\n    }\n  }\n\n  .auth-modal {\n    .ant-modal {\n      margin: 10px;\n      max-width: calc(100vw - 20px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
